<div class="transport-issues-dialog">

  <div class="dialog-layout">

    <h2 class="dialog-h2">
      <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport-issues-dialog.title"></sc-dictionary-label>
    </h2>



    <div class="top-info">
      <app-transport-info-panel [carrier]="transport.carrier" [identifier]="transport.identifier"
        [driver]="transport.driver" [scope]="transport.transportScope"></app-transport-info-panel>
    </div>

    <div class="dialog-content">

      <form #editForm="ngForm">
        <sc-flex vertical stretchContent fitHeight [gap]="16">
          <sc-tile *ngFor="let issue of getNonDeletedIssues()">
            <sc-padding>
              <div class="issue-box no-field-space">

                <mat-form-field style="grid-column: 1; grid-row: 1;" appearance="fill">
                  <mat-label>
                    <sc-dictionary-label dictionaryKey="tmc-yard.common.type"></sc-dictionary-label>
                  </mat-label>
                  <mat-select [required]="true" name="{{'type_' + issue.id}}" [(ngModel)]="issue.issueTypeId"
                    (selectionChange)="onTypeSelectionChange($event, issue)">
                    <mat-option *ngFor="let o of transport.issueTypes" [value]="o.id">
                      <sc-dictionary-label [dictionaryKey]="o.nameDictionaryKey"></sc-dictionary-label>
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field style="grid-column: 2; grid-row: 1;" appearance="fill">
                  <mat-label>
                    <sc-dictionary-label
                      dictionaryKey="tmc-yard.ui.transport-issues-dialog.label.delay"></sc-dictionary-label>
                  </mat-label>
                  <input name="{{'delay_' + issue.id}}" matInput [(ngModel)]="issue.delay" #ctrlDelay="ngModel"
                    type="number" [required]="true" [readonly]="false" required appPositiveInteger min="0"
                    (keydown.enter)="preventEnterKeydown()">
                  <mat-error *ngIf="showValuePositiveIntegerError(ctrlDelay)">
                    <sc-dictionary-label
                      dictionaryKey="tmc-yard.ui.transport-issues-dialog.error.delay-no-integer"></sc-dictionary-label>
                  </mat-error>
                </mat-form-field>

                <mat-form-field style="grid-column: 1 / span 2; grid-row: 2;" appearance="fill">
                  <mat-label>
                    <sc-dictionary-label dictionaryKey="tmc-yard.common.description"></sc-dictionary-label>
                  </mat-label>
                  <textarea name="{{'text_'+issue.id}}" matInput [(ngModel)]="issue.text"
                    [required]="cps.isPropertyTrue('ui-component.transport-issues-dialog.text.min-length', true)"
                    [minLength]="+cps.getPropertyValue('ui-component.transport-issues-dialog.text.min-length', '0')"
                    [maxlength]="9999" cdkTextareaAutosize cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5">
                  </textarea>
                </mat-form-field>

                <div class="centered" style="grid-column: 3; grid-row: 1 / span 2;">
                  <sc-delete-action-button (click)="removeIssue(issue)" [disabled]="isRemoveIssueDisabled(issue)">
                  </sc-delete-action-button>
                </div>
              </div>
            </sc-padding>
          </sc-tile>
        </sc-flex>
      </form>

      <sc-content-spacer vertical></sc-content-spacer>

      <div class="add-button-wrapper">
        <sc-button class="add-issue-button" (click)="addIssue()" [disabled]="isAddIssueDisabled()"
          dictionaryKey="tmc-yard.ui.transport-issues-dialog.action.addIssue">
          <sc-icon iconClass="fa-plus"></sc-icon>
        </sc-button>
      </div>

    </div>

    <div>

      <div class="messages">
        <app-service-response [responseMessages]="responseMessages"></app-service-response>
      </div>

      <sc-actionbar>
        <sc-content-spacer grow></sc-content-spacer>
        <sc-cancel-button (click)="cancel()" dictionaryKey="tmc-yard.common.action.cancel"></sc-cancel-button>
        <sc-content-spacer></sc-content-spacer>
        <sc-save-button primary (click)="save()" [disabled]="isSaveDisabled()"
          dictionaryKey="tmc-yard.common.action.save">
        </sc-save-button>
      </sc-actionbar>

    </div>

  </div>
